export const MinutesOfADay = 24 * 60

export const Weekdays = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
]

export const TargetVisitorConsts = {
  MAX_DAYS: 365,
  MIN_DAYS: 1,
  MAX_HOURS: 23,
  MIN_HOURS: 0,
  // maxは365日、defaultは180日
  MAX_MINUTES: 365 * 24 * 60,
  DEFAULT_MINUTES: 180 * 24 * 60,
  MIN_MINUTES: 60,
}

export const MenuTargets = {
  VISITOR: 'visitor',
  RESIDENT: 'resident',
}

export const BudgetPacingTypes = {
  EVEN_PACE: 'even pace',
  DAILY_LIMIT: 'daily limit',
}

export const Campaign = {
  deliveryLocationGroups: {
    maxSize: 99,
    defaultRadius: 1000,
  },
  menuSetting: {
    defaults: {
      useLowQualityLocation: true,
      radius: null,
      enableBulkSetting: false,
    },
  },
}

export const GoalTypes = {
  CPC: 'cpc',
  NONE: 'none',
}

export const DeliveryDevices = {
  PC: 'pc',
  TABLET: 'tablet',
  PHONE: 'phone',
}

export const DeliveryInventories = {
  WEB: 'web',
  MOBILE_WEB: 'mobile_web',
  MOBILE_APP: 'mobile_app',
}

export const PacingTypes = {
  EVEN_PACE: 'even pace',
  DAILY_LIMIT: 'daily limit',
}

// @note クリエイティブモデルができたらそちらに統合すべき
export const CreativeTypes = {
  BANNER: 'banner',
}

export const CreativeAttachTargets = {
  CAMPAIGN: 'campaign',
  DELIVERY_GROUP: 'delivery group',
}

export const InventoryListTargetingUsePolicies = {
  RECOMMENDED: 'recommended',
  OPTIONAL: 'optional',
  REQUIRED: 'required',
}

export const IpAreaTypes = {
  COUNTRY: 'country',
  REGION: 'region',
  CITY: 'city',
}

export const DateTimeFormat = 'YYYY-MM-DD HH:mm:ss'

// IPエリアの国は日本に固定（DBには同じidで登録しておくこと）
export const IP_AREA_JP_ID = 1

export const TargetAreaTypes = {
  PREFECTURE: 'prefecture',
  CITY: 'city',
}
